import moment from 'moment';

import {
  DaySchedule,
  PersonAbsence,
  Shift,
  SpecialDayTypeEnum,
  TaskForCalendarAssignment,
  TimelineScale
} from '../../types/interfaces';
import { generateGUID } from '../../utils';

export function createIdGenerator(start = 1) {
  let current = start;
  return () => current++;
}

export const createTaskIdGenerator = () => {
  let id = 0;
  return () => `task-${++id}`;
};

export const computeTaskInterval = (task: TaskForCalendarAssignment) => {
  const regMoment = moment(task.factStart ?? task.planStart ?? task.creationTime);
  let end: moment.Moment;
  if (task.factFinish) {
    end = moment(task.factFinish);
  } else if (task.planFinish) {
    end = moment(task.planFinish);
  } else {
    end = regMoment.clone().startOf('day').add(1, 'day');
  }
  return { start: regMoment, end };
};

export const formatScheduleTitle = (
  item: DaySchedule | PersonAbsence | null,
  timelineScale: TimelineScale
): string => {
  if (!item) return '';

  let start: string;
  let end: string;
  let shortName: undefined | string = undefined;

  if ('workdayStart' in item) {
    start = `${item.start.split('T')[0]}T${item.workdayStart}:00Z`;
    const [hours, minutes] = item.workdayDuration.split(':').map(Number);
    end = moment
      .utc(start)
      .add(hours, 'hours')
      .add(minutes, 'minutes')
      .toISOString();
  } else {
    start = item.from;
    end = item.to;
    shortName = `${item.absence.shortName}`;
  }

  const startMoment = 'workdayStart' in item ? moment.utc(start) : moment.utc(start).local();
  const endMoment = 'workdayStart' in item ? moment.utc(end) : moment.utc(end).local();

  return `${startMoment.format('HH:mm')} ${
    timelineScale !== TimelineScale.MONTH ? '- ' : ''
  }${endMoment.format('HH:mm')}${shortName ? ' ' + shortName : ''}`;
};

export function getDayBackgroundColor(dayType?: SpecialDayTypeEnum): string {
  switch (dayType) {
  case SpecialDayTypeEnum.DayOff:
  case SpecialDayTypeEnum.WeeklyDayOff:
  case SpecialDayTypeEnum.Holiday:
  case SpecialDayTypeEnum.WeeklyHoliday:
    return 'pink';
  case SpecialDayTypeEnum.HalfDay:
  case SpecialDayTypeEnum.WeeklyHalfDay:
    return 'yellow';
  default:
    return 'blue';
  }
}

export const shiftToDaySchedule = (shift: Shift): DaySchedule => {
  const localDateTime = moment(`${shift.date}T${shift.workdayStart}:00`);
  const startUtc = localDateTime.utc().format('YYYY-MM-DDTHH:mm:ss');
  const [h, m] = shift.workdayDuration.split(':').map(Number);
  const endUtc = localDateTime
    .clone()
    .add({ hours: h, minutes: m })
    .utc()
    .format('YYYY-MM-DDTHH:mm:ss');

  return {
    id: shift.id,
    start: startUtc,
    end: endUtc,
    departmentId: shift.departmentId,
    workdayStart: shift.workdayStart,
    workdayDuration: shift.workdayDuration,
    break: shift.breakDuration,
    isTemplate: shift.isTemplate ?? false,
    guid: shift.guid || generateGUID()
  };
};


